export default __webpack_public_path__ + "static/media/BehaviorBreakdownDesktop.21ba2845.png";